import * as React from 'react';
import { ModalInformation, ModalInformationProps } from '../ModalInformation';

interface ModalSuccessProps extends ModalInformationProps {}

export const ModalSuccess = (props: ModalSuccessProps) => {
  const { children, ...rest } = props;

  return (
    <ModalInformation type="success" {...rest}>
      {children}
    </ModalInformation>
  );
};

ModalSuccess.create = () => ModalInformation.create('success');
